<template>
  <div>
    <b-row class="justify-content-start">
      <b-col md="2" class="w-100" v-if="type == 'BULK'">
        <back-button :returnUrl="returnUrl"></back-button>
      </b-col>
    </b-row>
    <b-row class="mb-5 justify-content-start ml-0">
      <!-- Left section filtre -->
      <b-col cols="4" lg="2" xl="2" class="mt-2 pl-0">
        <b-button class="btnFilter"
          @click="displayFilter = !displayFilter">
          <i v-if="displayFilter" class="fa-light fa-minus"></i>
          <i v-else class="fa-light fa-plus"></i>
          {{ $t('filter.fltr') }}
        </b-button>
      </b-col>
      <b-col cols="4" lg="2" xl="2" class="mt-2">
        <b-button class="btnFilter"
          @click="refreshInbox()">
          <i class="fa-light fa-rotate-right"></i>
          {{ $t('common.rfrsh') }}
        </b-button>
      </b-col>
    </b-row>
    <b-row class="min-w-100 justify-content-start align-items-center" >
      <!--Filtre IBAN -->
      <b-col v-if="displayFilter" sm="6" lg="3" cols="12" class="filter-item mb-5">
        <label class="filter-item-title" for="filter-iban">{{ $t('account_tb.name') }}</label>
        <span class="filter-item-content">
          <input v-model.trim="Name"
                 id="filter-iban"
                 type="text"
                 :class="{'filter-item-input': true, 'filter-item-input-complete': Name}"
                 :placeholder="$t('account_tb.name')"
                 style="width: 100%">
        </span>
      </b-col>
    </b-row>
    <b-row class="min-w-100 justify-content-end mb-5 mr-1" v-if="displayFilter">
      <!-- Bouton Effacer et Appliquer -->
      <b-col lg="3" cols="12" class="d-flex flex-row-reverse mt-3">
        <b-button size="sm"
          @click="applyFilter()">
          {{ $t('common.srch') }}
        </b-button>
        <b-button class="mr-3" size="sm"
          @click="clearFilterFields"
          :disabled="!hasInputFilter">
          {{ $t('filter.clr_fltr_field') }}
        </b-button>
      </b-col>
    </b-row>
   <div class="d-flex justify-content-end" v-if="AccountTBList.length > 0">
      <b-button class="btnFilter_2 ml-3"
        @click="extractCSV()"
        disabled>
        <i class="fa-light fa-upload fs-14px"></i>
        <span class="fab-label">{{ $t('common.extract_page') }}</span>
      </b-button>
    </div>
    <spinner v-if="activateSpinner"></spinner>
    <div v-else-if="AccountTBList.length > 0" style="overflow:auto">
      <chart-pie-stat v-if="AccountTBStat.length > 0" :stat="AccountTBStat"></chart-pie-stat>
      <div v-else class="d-flex justify-content-center">
      <span class="noResult">
        {{ $t('account_tb.no_data') }}
      </span>
      </div>
      <b-table hover
        class="table table-striped mt-5"
        style="margin-bottom:0"
        :fields="fields"
        :items="AccountTBList"
        :selectable="AccountTBList.length > 0"
        :empty-text="$t('common.security.no_result')"
        @row-clicked="seeAccountTBDetails">
        <template #cell(IsRVM)="data"><div class="text-ellipsis"><i v-if="data.item.IsRVM == 1" class="fa-solid fa-check text-success"></i><i v-else class="fa-solid fa-xmark text-danger"></i></div></template>
        <template #cell(SessionTest)="data"><div class="text-ellipsis">{{ getSessionTestStatus(data.item.StartDate, data.item.EndDate) }}</div></template>
        <template #cell(Progress)="data"><div class="text-ellipsis">{{ data.item.TotalOk == '' ? 0: ((data.item.TotalOk/data.item.TotalTest)* 100).toFixed(2) }} %</div></template>
      </b-table>
    </div>
    <div v-else class="d-flex justify-content-center">
      <span class="noResult">
        {{ $t('common.no_result') }}
      </span>
    </div>
    <b-row class="mt-5">
      <b-col cols="12">
        <cm-pagination
          :maxResultsByPage="paginationObject.maxResults"
          :firstIndex="paginationObject.firstIndex"
          :nbResultsTotal="paginationObject.nbResultsTotal"
          :refreshEvent="paginationObject.refresh">
        </cm-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import conf from '../../config/config.dev.js'
import moment from 'moment-timezone'
import Pagination from '@/components/common/pagination.vue'
import Spinner from '@/components/common/spinner.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import {downloadFileWithDefinedHeaders} from "@/helpers/download"
import BackButton from "@/components/common/backButton.vue"
import ChartPieStat from "@/pages/accountTB/ChartPieStat.vue";


export default {
  name: 'AccountPage',
  components: {
    ChartPieStat,
    BackButton,
    'cm-pagination': Pagination,
    'spinner': Spinner,
    'datetime-picker-custom': dateTimePicker,
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    type: {
      default: 'DDV',
      type: String
    },
    id: {
      default: 'NULL',
      type: String
    }
  },
  computed: {
    fields () {
      let fields
      fields = [
        { key: 'Name', label: this.$i18n.t('account_tb.name'), class: 'text-center', sortable: false },
        { key: 'IsRVM', label: this.$i18n.t('account_tb.is_rvm'), class: 'text-center', sortable: false },
        { key: 'SessionTest', label: this.$i18n.t('account_tb.session_test.session_test_title'), class: 'text-center', sortable: false },
        { key: 'Progress', label: this.$i18n.t('account_tb.progress_percentage'), class: 'text-center', sortable: false },
      ]

      return fields
    },
    company_nameDirection () {
      return ((this.sortField === 'company_name' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    statusVerificationDirection () {
      return ((this.sortField === 'statusVerification' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    activeDirection () {
      return ((this.sortField === 'active' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    hasInputFilter () {
      if (
          this.Name ||
          this.Result ) {
        return true
      }
      return false
    },
  },
  data () {
    return {
      timezone: '+00:00',
      isMandatoryFieldMiss: true,
      activateSpinner: false,
      displayFilter: false,
      filterBy: '',
      hasDefaultFilter: false,
      statusVerification: '',
      VopProvider: '',
      Result: '',
      Name: '',
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollFlag: true,
      sortDirection: 'DESC',
      sortField: 'dateAction',
      AccountTBList: [],
      AccountTBStat: [],
    }
  },
  created () {
    this.timezone = moment.tz.guess()
    
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start',
      navTitle: 'Tracking',
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.onRefresh(false, index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false)

    this.filterTypeGet = this.filterType
    this.$bus.emit('right-panel-set-feature', 'filter-messages')
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
  },
  beforeDestroy () {
    let that = this
    that.$engine.firstOn().tracking.cleanFilterCondition()
  },
  methods: {
    applyFilter (filterConditions = {}) {
      if(this.tabName !== 2 && this.dateBegin === ''){
        this.isMandatoryFieldMiss = false
        return
      }
      this.isMandatoryFieldMiss = false
      this.AccountTBList = []
      this.AccountTBStat = []
      let that = this
      this.filterTypeGet = 'list'

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['maxResults'] = 15
      this.paginationObject['nbResultsTotal'] = 0
      this.activateSpinner = true
      this.$engine.firstOn().tracking.cleanFilterCondition()

      filterConditions.Name = this.Name.trim()

      this.$engine.firstOn().accountTB.getAccountTB(
        filterConditions
      ).then(resp => {
        let requests = {}
        if (resp.data && resp.data.accounts.length > 0){
          that.paginationObject.nbResultsTotal = resp.data.countAccountTBs
          that.paginationObject.nbResults = resp.data.accounts.length
          requests = resp.data
          that.updateInbox(requests)
        }
        // this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    communicateChange () {
      this.$bus.emit('right-panel-filter-view-update-fields', this.filterFields)
    },
    clearFilterFields () {
      this.isMandatoryFieldMiss = true
      this.paginationObject = {}
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['maxResults'] = 15
      this.paginationObject['nbResultsTotal'] = 0
      this.paginationObject['refresh'] = 'direct-inbox-filtered'
      this.Name = ''
      this.communicateChange()
      this.AccountTBList = []
      this.AccountTBStat = []
      this.applyFilter()
    },
    attachInfinit () {
      if (this.$settings.inboxPreloaderRemoved ||
          this.$settings.sendboxPreloaderRemoved) {
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.firstOn().settings.set({inboxPreloaderRemoved: false})
      }
      this.scrollFlag = true
      this.noMore = false
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.firstOn().settings.set({inboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    onClear () {
      this.filterBy = ''
      this.attachInfinit()
    },
    onDisable () {
      this.attachInfinit()
    },
    onEnable () {
      this.detachInfinit()
    },
    onRefresh (noAttach = false, index = 1) {
      let that = this
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true
      let filterConditions = {
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex,
        Name: this.Name.trim(),
      }

      this.$engine.firstOn().accountTB.getAccountTB(
        filterConditions
      ).then(resp => {
        this.AccountTBList = []
        this.AccountTBStat = []
        let requests = {}
        if (resp.data && resp.data.accounts.length > 0) {
          that.paginationObject.nbResultsTotal = resp.data.countAccountTBs
          that.paginationObject.nbResults = resp.data.accounts.length
          requests = resp.data
          that.updateInbox(requests, noAttach)
          that.$f7.pullToRefreshDone()
          that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        }
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    extractCSV (){
      let utcOffsetMinutes = moment().utcOffset()
      let utcOffsetHours = utcOffsetMinutes / 60
      let that = this
      this.pageCounter = 0
      // this.paginationObject['firstIndex'] = 1
      // this.paginationObject['nbResultsTotal'] = 0

      let filterConditions = {
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex,
        extract : 1,
        OffsetUTC: (utcOffsetHours >= 0 ? '+' : '')+ utcOffsetHours,
        Name: this.Name.trim(),
      }
      
      this.$engine.firstOn().accountTB.getAccountTB(
        filterConditions
      ).then(resp => {
        that.$f7.hidePreloader()

        const binaryString = window.atob(resp.data)
        const len = binaryString.length
        const bytes = new Uint8Array(len)
        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i)
        }

        const csvData = new TextDecoder('utf-8').decode(bytes)

        const rows = csvData.split('\n').map(row => row.split(';'))
        const headers = rows[0].map(header => header.replace(/\"/g, '').trim())
        const dataIndex = headers.indexOf('RequestStatus')

        const modifiedRows = rows.map((row, index) => {
          if (index === 0) return row
          if (row[dataIndex] && dataIndex !== -1) {
            row[dataIndex] = that.translateTechStatusCode(row[dataIndex])
          } else{
            row[dataIndex] = that.$t('common.monitoring.success')
          }
          return row
        })

        const modifiedCsv = "\ufeff" + modifiedRows.map(row => row.join(';')).join('\n')

        const linkSource = 'data:text/csv;charset=utf-8,' + encodeURIComponent(modifiedCsv)
        const downloadLink = document.createElement('a')
        let today = moment()
        const fileName = this.$t('Webheader.tracking') + '_' + today.unix() + '.csv'

        if (this.$f7.device.os === 'android' || this.$f7.device.os === 'ios') {
          downloadFileWithDefinedHeaders(this, fileName, linkSource)
        } else {
          downloadLink.href = linkSource
          downloadLink.download = fileName
          downloadLink.click()
        }

        this.$f7.alert('', this.$i18n.t('common.exprt_succ'))
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    refreshInbox () {
      this.onRefresh()
    },
    activateDetail (id) {
      let that = this
      loadPage(that, {url: '/accountTBdetails/' + id})
    },
    reOrderBy (column) {
      this.AccountTBList = []
      this.AccountTBStat = []
      let that = this
      if (this.sortField === column) {
        this.sortDirection = this.sortDirection === 'ASC' ? 'DESC' : 'ASC'
      } else {
        this.sortField = column
        switch (column) {
          case 'dateAction':
            this.sortDirection = 'DESC'
        }
      }
      let filterConditions

      // if (this.id !== 'NULL'){
      //   filterConditions.IdBulk = this.id
      // }
      this.$engine.firstOn().accountTB.getAccountTB(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResultsTotal = resp.data.countAccountTBs
        that.paginationObject.nbResults = resp.data.tracks.length
        requests = resp.data
        that.updateInbox(requests, false)
        that.$f7.pullToRefreshDone()
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    updateInbox (requests, noAttach = false) {
      this.AccountTBList = requests.accounts
      this.AccountTBStat = requests.stat
      if (requests.accounts.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    seeAccountTBDetails (items) {
      this.activateDetail(items.IdAccount)
    },
    getSessionTestStatus(StartDate, EndDate) {
      const now = new Date()

      if (!StartDate || !EndDate) {
        return this.$t('account_tb.session_test.no_enrollment')
      }

      const start = new Date(StartDate)
      const end = new Date(EndDate)

      if (end < now) {
        return this.$t('account_tb.session_test.no_enrollment')
      }

      if (start > now) {
        return this.$t('account_tb.session_test.scheduled_upcoming')
      }

      return this.$t('account_tb.session_test.in_progress')
    }
  }
}
</script>

<style scoped>
.result-vignette {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
}

.result-mtch {
  background-color: rgba(0, 143, 57, 0.8);
}

.result-nmtc {
  background-color: rgba(204, 0, 0, 0.8);
}

.result-cmtc {
  background-color: rgba(230, 159, 0, 0.8);
}

.result-noap {
  background-color: rgba(153, 153, 153, 0.8);
}
</style>
